import {useState} from "react";
import {BiLogoKubernetes} from "react-icons/bi";
import {FaDocker, FaUbuntu} from "react-icons/fa";
import {FaChevronDown} from "react-icons/fa6";
import {SiPhoton} from "react-icons/si";

import Button from "@/components/button/Button.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {Icon} from "@/components/icon/Icon.tsx";
import {DropdownAction} from "@/components/quickActionsBar/DropdownAction.tsx";
import {PRIVATE_LOCATION_PHOTON_INSTALL_URL, PRIVATE_LOCATION_SUPPORT_URL, URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";
import {Platform, PlatformDisplay, PrivateLocation} from "@/lib/types/monitoring.ts";
import {DeployAssistant} from "@/pages/monitoring/privatelocations/list/tableComponents/deployAssistant/DeployAssistant.tsx";

interface PlatformDropdownProps {
  privateLocationData: PrivateLocation;
}

export const PlatformDropdown = ({privateLocationData}: PlatformDropdownProps) => {
  const {user} = useCurrentUserContext();
  const [selectedPlatform, setSelectedPlatform] = useState<Platform | null>(null);
  const [showPrivateLocationDialog, setShowPrivateLocationDialog] = useState(false);

  const handleCloseDialog = () => {
    setSelectedPlatform(null);
    setShowPrivateLocationDialog(false);
  };

  return (
    <>
      <DropdownAction
        id={`selectPlatformDropdown-${privateLocationData.id}`}
        buttonContent={
          <Button
            variant={"secondary"}
            size={"extraSmall"}
            className={"text-nowrap"}
            disabled={!user?.has_admin_access}
          >
            Select Platform <Icon icon={FaChevronDown} />
          </Button>
        }
        items={[
          <Button
            variant={"dropdownMenuItem"}
            as={"a"}
            href={`${URL_ORIGINAL_WEBSITE}/monitoring/private-locations/download-script?server_id=${privateLocationData.id}&platform=${Platform.UBUNTU}`}
            onClick={() => {
              setShowPrivateLocationDialog(true);
              setSelectedPlatform(Platform.UBUNTU);
            }}
          >
            <div className={"d-flex gap-2 align-items-center"}>
              <Icon icon={FaUbuntu} />
              {PlatformDisplay[Platform.UBUNTU]}
            </div>
          </Button>,
          <Button
            variant={"dropdownMenuItem"}
            as={"a"}
            href={`${URL_ORIGINAL_WEBSITE}/monitoring/private-locations/download-script?server_id=${privateLocationData.id}&platform=${Platform.KUBERNETES}`}
            onClick={() => {
              setShowPrivateLocationDialog(true);
              setSelectedPlatform(Platform.KUBERNETES);
            }}
          >
            <div className={"d-flex gap-2 align-items-center"}>
              <Icon icon={BiLogoKubernetes} />
              {PlatformDisplay[Platform.KUBERNETES]}
            </div>
          </Button>,
          <Button
            variant={"dropdownMenuItem"}
            as={"a"}
            onClick={() => {
              window.open(PRIVATE_LOCATION_PHOTON_INSTALL_URL, "_blank");
              setSelectedPlatform(Platform.PHOTON);
            }}
          >
            <div className={"d-flex gap-2 align-items-center"}>
              <Icon icon={SiPhoton} />
              {PlatformDisplay[Platform.PHOTON]}
            </div>
          </Button>,
          <Button
            variant={"dropdownMenuItem"}
            as={"a"}
            onClick={() => {
              window.open(PRIVATE_LOCATION_SUPPORT_URL, "_blank");
              setSelectedPlatform(Platform.MANUAL);
            }}
          >
            <div className={"d-flex gap-2 align-items-center"}>
              <Icon icon={FaDocker} />
              {PlatformDisplay[Platform.MANUAL]}
            </div>
          </Button>,
        ]}
      />
      {selectedPlatform && showPrivateLocationDialog && (
        <DeployAssistant platform={selectedPlatform} onClose={handleCloseDialog} />
      )}
    </>
  );
};
